import { toRefs, computed } from 'vue';
import { useTheme } from '../../compositions/component-lib.esm3.js';
import { getThemeColor } from '../../styles/theme/component-lib.esm.js';

//
var script = {
  name: 'FormGroupHelp',
  props: {
    color: {
      type: String,
      default: 'gray600'
    },
    gutterBottom: Boolean
  },
  setup(props) {
    const {
      color,
      gutterBottom
    } = toRefs(props);
    const theme = useTheme();
    const classes = computed(() => {
      return {
        'v-form-group-help--gutter-btm': gutterBottom.value
      };
    });
    const styles = computed(() => {
      return {
        '--c-color': getThemeColor(color.value, theme.value)
      };
    });
    return {
      classes,
      styles
    };
  }
};
export { script as default };